import React from "react";
import {Button} from "reactstrap";
import PropTypes from "prop-types";
import "../../assets/scss/argon-dashboard-react.scss";
import "./style.scss";

/** This component is wrapper around reactstrap Button component with few added functionalities */

const ZeusButton = (props) => {
  const {
    children,
    classes = "",
    type = "default",
    largeButton = false,
    withRadius = false,
    withShadow = false,
    ...rest
  } = props;

  return (
    <Button
      className={`${classes} zeusButton ${type} ${largeButton ? "largeButton" : ""} ${
        withShadow ? "defaultShadow" : ""
      } ${withRadius ? "withRadius" : ""} button--for--smallscreen roboto-bold`}
      {...rest}
    >
      {children}
    </Button>
  );
};

ZeusButton.propTypes = {
  children: PropTypes.node.isRequired,
  /** this prop will pass css classes to button */
  classes: PropTypes.string,
  /** this prop will determine width of button */
  largeButton: PropTypes.bool,
  /** this prop will determine wether button will have box shadow */
  withShadow: PropTypes.bool,
  /** this prop will determine wether button will have border radius */
  withRadius: PropTypes.bool,
  type: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "info",
    "info-small",
    "info-color",
    "notification-button",
  ]),
};

export default ZeusButton;
